// MEO landmark ads (Phase 1, Step 4-3): landmarks 管理用 MobX store。
// 既存 ItemStore のパターンを踏襲。

import { LandmarkApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class LandmarkStore extends BaseStore {
    landmarks: any[] = [];
    landmark: any = null;
    total: number = 0;
    api: LandmarkApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            landmarks: observable,
            landmark: observable,
            total: observable,
            list: flow.bound,
            getById: flow.bound,
            create: flow.bound,
            update: flow.bound,
            remove: flow.bound,
            updateReviewBonusStrategy: flow.bound
        });
        this.api = new LandmarkApi();
    }

    *list(searchParams?: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.list, searchParams);
            if (res?.ok) {
                // backend response: { total, page, limit, items }
                this.landmarks = res.data?.items ?? [];
                this.total = res.data?.total ?? 0;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *getById(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getById, id);
            if (res?.ok) {
                this.landmark = res.data;
            }
            return res;
        } catch (_e) {
            return null;
        }
    }

    *create(payload: any) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.create, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *update(payload: { id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.update, payload);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    *remove(id: string | number) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.remove, id);
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }

    // MEO Phase 1 Sprint 2-F (2026-05-13): review_bonus_strategy dedicated update
    *updateReviewBonusStrategy(payload: { id: string | number, data: any }) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(
                this.api,
                this.api.updateReviewBonusStrategy,
                payload
            );
            return res;
        } catch (e: any) {
            return e?.data;
        }
    }
}
